/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../../public/upgrade/feature/pointOfSale/edit/special-attention-hours/special-attention-hours.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../../../public/upgrade/core/logger.service';
import * as import10 from '@ngx-translate/core/src/translate.service';
import * as import11 from '../../../../../../../public/upgrade/root/ga/ga.service';
import * as import12 from '@angular/core/src/linker/view_container';
import * as import13 from '../../../../../../../public/upgrade/shared/input-container/input-container.component';
import * as import14 from '../../../../shared/input-container/input-container.component.ngfactory';
import * as import15 from '../../../../../../../public/upgrade/shared/select-container/select-container.component';
import * as import16 from '../../../../shared/select-container/select-container.component.ngfactory';
import * as import17 from '../../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import18 from '../../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import19 from '@ngx-translate/core/src/translate.pipe';
import * as import20 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import21 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import22 from '@angular/core/src/linker/element_ref';
import * as import23 from '@angular/core/src/linker/template_ref';
import * as import24 from '@angular/common/src/directives/ng_class';
import * as import25 from '@angular/common/src/directives/ng_for';
export class Wrapper_SpecialAttentionHoursComponent {
  /*private*/ _eventHandler:Function;
  context:import0.SpecialAttentionHoursComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  constructor(p0:any,p1:any,p2:any) {
    this._changed = false;
    this.context = new import0.SpecialAttentionHoursComponent(p0,p1,p2);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_dto(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.dto = currValue;
      this._expr_0 = currValue;
    }
  }
  check_isEditing(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.isEditing = currValue;
      this._expr_1 = currValue;
    }
  }
  check_errors(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.errors = currValue;
      this._expr_2 = currValue;
    }
  }
  check_errorMessages(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.errorMessages = currValue;
      this._expr_3 = currValue;
    }
  }
  check_data(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.data = currValue;
      this._expr_4 = currValue;
    }
  }
  check_rangeFrom(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this._changed = true;
      this.context.rangeFrom = currValue;
      this._expr_5 = currValue;
    }
  }
  check_rangeTo(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_6,currValue))) {
      this._changed = true;
      this.context.rangeTo = currValue;
      this._expr_6 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_SpecialAttentionHoursComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_SpecialAttentionHoursComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.SpecialAttentionHoursComponent>;
  _SpecialAttentionHoursComponent_0_3:Wrapper_SpecialAttentionHoursComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SpecialAttentionHoursComponent_Host0,renderType_SpecialAttentionHoursComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'special-attention-hours',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_SpecialAttentionHoursComponent0(this.viewUtils,this,0,this._el_0);
    this._SpecialAttentionHoursComponent_0_3 = new Wrapper_SpecialAttentionHoursComponent(this.injectorGet(import9.LoggerService,this.parentIndex),this.injectorGet(import10.TranslateService,this.parentIndex),this.injectorGet(import11.GAService,this.parentIndex));
    this.compView_0.create(this._SpecialAttentionHoursComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._SpecialAttentionHoursComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SpecialAttentionHoursComponent) && (0 === requestNodeIndex))) { return this._SpecialAttentionHoursComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SpecialAttentionHoursComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const SpecialAttentionHoursComponentNgFactory:import8.ComponentFactory<import0.SpecialAttentionHoursComponent> = new import8.ComponentFactory<import0.SpecialAttentionHoursComponent>('special-attention-hours',View_SpecialAttentionHoursComponent_Host0,import0.SpecialAttentionHoursComponent);
const styles_SpecialAttentionHoursComponent:any[] = ([] as any[]);
class View_SpecialAttentionHoursComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  /*private*/ _expr_7:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SpecialAttentionHoursComponent1,renderType_SpecialAttentionHoursComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_7 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','eva-3-tag -active'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','tag-text'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','tag-icon eva-3-icon-close'),(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_5,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_5));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_7:any = import3.inlineInterpolate(1,'',((this.parentView.context.normalizeHoursView(this.context.$implicit.rangeFrom) + ' - ') + this.parentView.context.normalizeHoursView(this.context.$implicit.rangeTo)),'');
    if (import3.checkBinding(throwOnChange,this._expr_7,currVal_7)) {
      this.renderer.setText(this._text_3,currVal_7);
      this._expr_7 = currVal_7;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_5(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.removeSpecialAttentionHour(this.context.index)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_SpecialAttentionHoursComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_SpecialAttentionHoursComponent,{});
export class View_SpecialAttentionHoursComponent0 extends import2.AppView<import0.SpecialAttentionHoursComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _el_18:any;
  compView_18:import2.AppView<import13.InputContainerComponent>;
  _InputContainerComponent_18_3:import14.Wrapper_InputContainerComponent;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _text_32:any;
  _el_33:any;
  _text_34:any;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _el_42:any;
  _el_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _text_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _el_53:any;
  _text_54:any;
  _el_55:any;
  _text_56:any;
  _el_57:any;
  compView_57:import2.AppView<import15.SelectContainerComponent>;
  _SelectContainerComponent_57_3:import16.Wrapper_SelectContainerComponent;
  _text_58:any;
  _text_59:any;
  _text_60:any;
  _el_61:any;
  _text_62:any;
  _el_63:any;
  compView_63:import2.AppView<import15.SelectContainerComponent>;
  _SelectContainerComponent_63_3:import16.Wrapper_SelectContainerComponent;
  _text_64:any;
  _text_65:any;
  _text_66:any;
  _el_67:any;
  _text_68:any;
  _el_69:any;
  _NgClass_69_3:import17.Wrapper_NgClass;
  _text_70:any;
  _el_71:any;
  _text_72:any;
  _text_73:any;
  _el_74:any;
  _text_75:any;
  _text_76:any;
  _text_77:any;
  _text_78:any;
  _text_79:any;
  _anchor_80:any;
  /*private*/ _vc_80:import12.ViewContainer;
  _TemplateRef_80_5:any;
  _NgFor_80_6:import18.Wrapper_NgFor;
  _text_81:any;
  /*private*/ _expr_92:any;
  _pipe_translate_0:import19.TranslatePipe;
  /*private*/ _expr_94:any;
  _pipe_translate_1:import19.TranslatePipe;
  /*private*/ _expr_96:any;
  _pipe_translate_2:import19.TranslatePipe;
  _pipe_translate_3:import19.TranslatePipe;
  /*private*/ _expr_99:any;
  /*private*/ _expr_100:any;
  _pipe_translate_4:import19.TranslatePipe;
  /*private*/ _expr_102:any;
  _pipe_translate_5:import19.TranslatePipe;
  /*private*/ _expr_104:any;
  _pipe_translate_6:import19.TranslatePipe;
  _pipe_translate_7:import19.TranslatePipe;
  _pipe_translate_8:import19.TranslatePipe;
  _pipe_translate_9:import19.TranslatePipe;
  _pipe_translate_10:import19.TranslatePipe;
  _map_110:any;
  /*private*/ _expr_111:any;
  _pipe_translate_11:import19.TranslatePipe;
  /*private*/ _expr_113:any;
  _pipe_translate_12:import19.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SpecialAttentionHoursComponent0,renderType_SpecialAttentionHoursComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_92 = import1.UNINITIALIZED;
    this._expr_94 = import1.UNINITIALIZED;
    this._expr_96 = import1.UNINITIALIZED;
    this._expr_99 = import1.UNINITIALIZED;
    this._expr_100 = import1.UNINITIALIZED;
    this._expr_102 = import1.UNINITIALIZED;
    this._expr_104 = import1.UNINITIALIZED;
    this._map_110 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._expr_111 = import1.UNINITIALIZED;
    this._expr_113 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray4(4,'class','eva-3-row','qadata','OfficeLocation'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_4,'p',new import3.InlineArray2(2,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_12 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-md'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n        ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_14,'div',new import3.InlineArray2(2,'class','col -lg-2 -md-2 -sm-10 special-attention-hour-amount'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n            ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_16,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_18 = new import14.View_InputContainerComponent0(this.viewUtils,this,18,this._el_18);
    this._InputContainerComponent_18_3 = new import14.Wrapper_InputContainerComponent();
    this._text_19 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_18.create(this._InputContainerComponent_18_3.context);
    this._text_20 = this.renderer.createText(this._el_16,'\n            ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_16,'span',new import3.InlineArray2(2,'class','eva-3-label -md special-attention-hour-currency'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'',(null as any));
    this._text_23 = this.renderer.createText(this._el_16,'\n        ',(null as any));
    this._text_24 = this.renderer.createText(this._el_14,'\n\n    ',(null as any));
    this._text_25 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row  -eva-3-pt-lg'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n        ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_26,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'\n            ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_28,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'',(null as any));
    this._text_32 = this.renderer.createText(this._el_28,'\n            ',(null as any));
    this._el_33 = import3.createRenderElement(this.renderer,this._el_28,'p',new import3.InlineArray2(2,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm'),(null as any));
    this._text_34 = this.renderer.createText(this._el_33,'',(null as any));
    this._text_35 = this.renderer.createText(this._el_28,'\n        ',(null as any));
    this._text_36 = this.renderer.createText(this._el_26,'\n    ',(null as any));
    this._text_37 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','row special-attention-hour-info'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'\n        ',(null as any));
    this._el_40 = import3.createRenderElement(this.renderer,this._el_38,'div',new import3.InlineArray2(2,'class','eva-3-message -info -no-title'),(null as any));
    this._text_41 = this.renderer.createText(this._el_40,'\n            ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_40,'div',new import3.InlineArray2(2,'class','message-icon-container'),(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_42,'i',new import3.InlineArray2(2,'class','message-icon eva-3-icon-info-circle'),(null as any));
    this._text_44 = this.renderer.createText(this._el_40,'\n            ',(null as any));
    this._el_45 = import3.createRenderElement(this.renderer,this._el_40,'div',new import3.InlineArray2(2,'class','message-body'),(null as any));
    this._text_46 = this.renderer.createText(this._el_45,'\n                ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_45,'p',new import3.InlineArray2(2,'class','message-text eva-3-p'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'',(null as any));
    this._text_49 = this.renderer.createText(this._el_45,'\n            ',(null as any));
    this._text_50 = this.renderer.createText(this._el_40,'\n        ',(null as any));
    this._text_51 = this.renderer.createText(this._el_38,'\n    ',(null as any));
    this._text_52 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_53 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-md'),(null as any));
    this._text_54 = this.renderer.createText(this._el_53,'\n            ',(null as any));
    this._el_55 = import3.createRenderElement(this.renderer,this._el_53,'div',new import3.InlineArray2(2,'class','col -lg-2 -md-2 -sm-12'),(null as any));
    this._text_56 = this.renderer.createText(this._el_55,'\n                ',(null as any));
    this._el_57 = import3.createRenderElement(this.renderer,this._el_55,'select-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_57 = new import16.View_SelectContainerComponent0(this.viewUtils,this,57,this._el_57);
    this._SelectContainerComponent_57_3 = new import16.Wrapper_SelectContainerComponent();
    this._text_58 = this.renderer.createText((null as any),'\n                ',(null as any));
    this.compView_57.create(this._SelectContainerComponent_57_3.context);
    this._text_59 = this.renderer.createText(this._el_55,'\n            ',(null as any));
    this._text_60 = this.renderer.createText(this._el_53,'\n\n            ',(null as any));
    this._el_61 = import3.createRenderElement(this.renderer,this._el_53,'div',new import3.InlineArray2(2,'class','col -lg-2 -md-2 -sm-12'),(null as any));
    this._text_62 = this.renderer.createText(this._el_61,'\n                ',(null as any));
    this._el_63 = import3.createRenderElement(this.renderer,this._el_61,'select-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_63 = new import16.View_SelectContainerComponent0(this.viewUtils,this,63,this._el_63);
    this._SelectContainerComponent_63_3 = new import16.Wrapper_SelectContainerComponent();
    this._text_64 = this.renderer.createText((null as any),'\n                ',(null as any));
    this.compView_63.create(this._SelectContainerComponent_63_3.context);
    this._text_65 = this.renderer.createText(this._el_61,'\n            ',(null as any));
    this._text_66 = this.renderer.createText(this._el_53,'\n        ',(null as any));
    this._el_67 = import3.createRenderElement(this.renderer,this._el_53,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12 -eva-3-pt-xlg'),(null as any));
    this._text_68 = this.renderer.createText(this._el_67,'\n            ',(null as any));
    this._el_69 = import3.createRenderElement(this.renderer,this._el_67,'div',new import3.InlineArray2(2,'class','eva-3-validation -lg -top-left'),(null as any));
    this._NgClass_69_3 = new import17.Wrapper_NgClass(this.parentView.injectorGet(import20.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import21.KeyValueDiffers,this.parentIndex),new import22.ElementRef(this._el_69),this.renderer);
    this._text_70 = this.renderer.createText(this._el_69,'\n                ',(null as any));
    this._el_71 = import3.createRenderElement(this.renderer,this._el_69,'dsp-button',new import3.InlineArray8(8,'name','saveButton','qadata','addHours','size','md','variation','ghost'),(null as any));
    this._text_72 = this.renderer.createText(this._el_71,'',(null as any));
    this._text_73 = this.renderer.createText(this._el_69,'\n                ',(null as any));
    this._el_74 = import3.createRenderElement(this.renderer,this._el_69,'span',new import3.InlineArray2(2,'class','validation-msg -eva-3-mb-sm'),(null as any));
    this._text_75 = this.renderer.createText(this._el_74,'',(null as any));
    this._text_76 = this.renderer.createText(this._el_69,'\n            ',(null as any));
    this._text_77 = this.renderer.createText(this._el_67,'\n        ',(null as any));
    this._text_78 = this.renderer.createText(this._el_53,'\n    ',(null as any));
    this._text_79 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    this._anchor_80 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_80 = new import12.ViewContainer(80,0,this,this._anchor_80);
    this._TemplateRef_80_5 = new import23.TemplateRef_(this,80,this._anchor_80);
    this._NgFor_80_6 = new import18.Wrapper_NgFor(this._vc_80.vcRef,this._TemplateRef_80_5,this.parentView.injectorGet(import20.IterableDiffers,this.parentIndex),this.ref);
    this._text_81 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_translate_0 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_18,new import3.InlineArray8(6,'modelChange',(null as any),'keypress',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_18));
    this._InputContainerComponent_18_3.subscribe(this,this.eventHandler(this.handleEvent_18),false,false,true);
    this._pipe_translate_2 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_5 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_57,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_57));
    this._SelectContainerComponent_57_3.subscribe(this,this.eventHandler(this.handleEvent_57),false,true);
    this._pipe_translate_7 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_8 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_63,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_63));
    this._SelectContainerComponent_63_3.subscribe(this,this.eventHandler(this.handleEvent_63),false,true);
    this._pipe_translate_9 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_10 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_71,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_71));
    this._pipe_translate_11 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_12 = new import19.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._text_32,
      this._el_33,
      this._text_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._el_42,
      this._el_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._text_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._el_55,
      this._text_56,
      this._el_57,
      this._text_58,
      this._text_59,
      this._text_60,
      this._el_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._text_65,
      this._text_66,
      this._el_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._el_71,
      this._text_72,
      this._text_73,
      this._el_74,
      this._text_75,
      this._text_76,
      this._text_77,
      this._text_78,
      this._text_79,
      this._anchor_80,
      this._text_81
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import13.InputContainerComponent) && ((18 <= requestNodeIndex) && (requestNodeIndex <= 19)))) { return this._InputContainerComponent_18_3.context; }
    if (((token === import15.SelectContainerComponent) && ((57 <= requestNodeIndex) && (requestNodeIndex <= 58)))) { return this._SelectContainerComponent_57_3.context; }
    if (((token === import15.SelectContainerComponent) && ((63 <= requestNodeIndex) && (requestNodeIndex <= 64)))) { return this._SelectContainerComponent_63_3.context; }
    if (((token === import24.NgClass) && ((69 <= requestNodeIndex) && (requestNodeIndex <= 76)))) { return this._NgClass_69_3.context; }
    if (((token === import23.TemplateRef) && (80 === requestNodeIndex))) { return this._TemplateRef_80_5; }
    if (((token === import25.NgFor) && (80 === requestNodeIndex))) { return this._NgFor_80_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_18_0_0:any = 'Ej 299.50';
    this._InputContainerComponent_18_3.check_placeholder(currVal_18_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_18_0_1:any = valUnwrapper.unwrap(this._pipe_translate_2.transform('pointOfSale.specialAttentionHours.AMOUNT_LABEL'));
    this._InputContainerComponent_18_3.check_label(currVal_18_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_18_0_2:boolean = !!this.context.validations.errors['amount'];
    this._InputContainerComponent_18_3.check_invalid(currVal_18_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_18_0_3:any = valUnwrapper.unwrap(this._pipe_translate_3.transform(this.context.validations.errors['amount']));
    this._InputContainerComponent_18_3.check_invalidText(currVal_18_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_18_0_4:any = this.context.amount;
    this._InputContainerComponent_18_3.check_model(currVal_18_0_4,throwOnChange,false);
    this._InputContainerComponent_18_3.ngDoCheck(this,this._el_18,throwOnChange);
    const currVal_57_0_0:any = 'range_from';
    this._SelectContainerComponent_57_3.check_id(currVal_57_0_0,throwOnChange,false);
    const currVal_57_0_1:any = 'range_from';
    this._SelectContainerComponent_57_3.check_name(currVal_57_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_57_0_2:any = valUnwrapper.unwrap(this._pipe_translate_7.transform('common.FROM'));
    this._SelectContainerComponent_57_3.check_label(currVal_57_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_57_0_3:any = 'md';
    this._SelectContainerComponent_57_3.check_size(currVal_57_0_3,throwOnChange,false);
    const currVal_57_0_4:boolean = !!this.context.validations.errors['rangeFrom'];
    this._SelectContainerComponent_57_3.check_invalid(currVal_57_0_4,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_57_0_5:any = valUnwrapper.unwrap(this._pipe_translate_8.transform(this.context.validations.errors['rangeFrom']));
    this._SelectContainerComponent_57_3.check_invalidText(currVal_57_0_5,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_57_0_6:any = this.context.hours;
    this._SelectContainerComponent_57_3.check_list(currVal_57_0_6,throwOnChange,false);
    const currVal_57_0_7:any = this.context.rangeFrom;
    this._SelectContainerComponent_57_3.check_model(currVal_57_0_7,throwOnChange,false);
    this._SelectContainerComponent_57_3.ngDoCheck(this,this._el_57,throwOnChange);
    const currVal_63_0_0:any = 'range_to';
    this._SelectContainerComponent_63_3.check_id(currVal_63_0_0,throwOnChange,false);
    const currVal_63_0_1:any = 'range_to';
    this._SelectContainerComponent_63_3.check_name(currVal_63_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_63_0_2:any = valUnwrapper.unwrap(this._pipe_translate_9.transform('common.TO'));
    this._SelectContainerComponent_63_3.check_label(currVal_63_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_63_0_3:any = 'md';
    this._SelectContainerComponent_63_3.check_size(currVal_63_0_3,throwOnChange,false);
    const currVal_63_0_4:boolean = !!this.context.validations.errors['rangeTo'];
    this._SelectContainerComponent_63_3.check_invalid(currVal_63_0_4,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_63_0_5:any = valUnwrapper.unwrap(this._pipe_translate_10.transform(this.context.validations.errors['rangeTo']));
    this._SelectContainerComponent_63_3.check_invalidText(currVal_63_0_5,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_63_0_6:any = this.context.hours;
    this._SelectContainerComponent_63_3.check_list(currVal_63_0_6,throwOnChange,false);
    const currVal_63_0_7:any = this.context.rangeTo;
    this._SelectContainerComponent_63_3.check_model(currVal_63_0_7,throwOnChange,false);
    this._SelectContainerComponent_63_3.ngDoCheck(this,this._el_63,throwOnChange);
    const currVal_69_0_0:any = 'eva-3-validation -lg -top-left';
    this._NgClass_69_3.check_klass(currVal_69_0_0,throwOnChange,false);
    const currVal_69_0_1:any = this._map_110(!!this.context.validations.errors['saveButton']);
    this._NgClass_69_3.check_ngClass(currVal_69_0_1,throwOnChange,false);
    this._NgClass_69_3.ngDoCheck(this,this._el_69,throwOnChange);
    const currVal_80_0_0:any = this.context.dto.specialAttentionHours;
    this._NgFor_80_6.check_ngForOf(currVal_80_0_0,throwOnChange,false);
    this._NgFor_80_6.ngDoCheck(this,this._anchor_80,throwOnChange);
    this._vc_80.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_92:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pointOfSale.specialAttentionHours.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_92,currVal_92))) {
      this.renderer.setText(this._text_7,currVal_92);
      this._expr_92 = currVal_92;
    }
    valUnwrapper.reset();
    const currVal_94:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('pointOfSale.specialAttentionHours.DESCRIPTION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_94,currVal_94))) {
      this.renderer.setText(this._text_10,currVal_94);
      this._expr_94 = currVal_94;
    }
    const currVal_96:any = this.context.amountPattern;
    if (import3.checkBinding(throwOnChange,this._expr_96,currVal_96)) {
      this.renderer.setElementProperty(this._el_18,'pattern',currVal_96);
      this._expr_96 = currVal_96;
    }
    const currVal_99:any = import3.inlineInterpolate(1,'',this.context.currency,'');
    if (import3.checkBinding(throwOnChange,this._expr_99,currVal_99)) {
      this.renderer.setText(this._text_22,currVal_99);
      this._expr_99 = currVal_99;
    }
    valUnwrapper.reset();
    const currVal_100:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('pointOfSale.specialAttentionHours.SPECIAL_RANGE_TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_100,currVal_100))) {
      this.renderer.setText(this._text_31,currVal_100);
      this._expr_100 = currVal_100;
    }
    valUnwrapper.reset();
    const currVal_102:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('pointOfSale.specialAttentionHours.SPECIAL_RANGE_DESCRIPTION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_102,currVal_102))) {
      this.renderer.setText(this._text_34,currVal_102);
      this._expr_102 = currVal_102;
    }
    valUnwrapper.reset();
    const currVal_104:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('pointOfSale.specialAttentionHours.INFO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_104,currVal_104))) {
      this.renderer.setText(this._text_48,currVal_104);
      this._expr_104 = currVal_104;
    }
    valUnwrapper.reset();
    const currVal_111:any = import3.inlineInterpolate(1,'\n                            ',valUnwrapper.unwrap(this._pipe_translate_11.transform('pointOfSale.specialAttentionHours.ADD')),'\n                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_111,currVal_111))) {
      this.renderer.setText(this._text_72,currVal_111);
      this._expr_111 = currVal_111;
    }
    valUnwrapper.reset();
    const currVal_113:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_12.transform(this.context.validations.errors['saveButton'])),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_113,currVal_113))) {
      this.renderer.setText(this._text_75,currVal_113);
      this._expr_113 = currVal_113;
    }
    this.compView_18.internalDetectChanges(throwOnChange);
    this.compView_57.internalDetectChanges(throwOnChange);
    this.compView_63.internalDetectChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._InputContainerComponent_18_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._SelectContainerComponent_57_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._SelectContainerComponent_63_3.context.ngAfterViewInit(); }
    }
  }
  destroyInternal():void {
    this._vc_80.destroyNestedViews();
    this.compView_18.destroy();
    this.compView_57.destroy();
    this.compView_63.destroy();
    this._InputContainerComponent_18_3.ngOnDestroy();
    this._SelectContainerComponent_57_3.ngOnDestroy();
    this._SelectContainerComponent_63_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
    this._pipe_translate_12.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 80)) { return new View_SpecialAttentionHoursComponent1(this.viewUtils,this,80,this._anchor_80,this._vc_80); }
    return (null as any);
  }
  handleEvent_18(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.amount = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'keypress')) {
      const pd_sub_1:any = ((<any>this.context.eventHandler($event)) !== false);
      result = (pd_sub_1 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_2:any = ((<any>this.context.amountChange()) !== false);
      result = (pd_sub_2 && result);
    }
    return result;
  }
  handleEvent_57(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.rangeFrom = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.context.updateValidations()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_63(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.rangeTo = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.context.updateValidations()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_71(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.handleClickButton()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pointOfSale/edit/special-attention-hours/special-attention-hours.component.ngfactory.ts